/**
 * Possible status types for the status service.
 */
export type StatusType = 'all' | 'summary';

/**
 * Information about a tasks from the SOML status.
 */
export type SomlStatusTask = {
  id: string;
  duration: number;
  operation: StatusTaskOperation;
  subOperations: Array<SomlStatusTask>
}

export enum StatusTaskOperation {
  CREATE = 'CREATE',
  BIND = 'BIND',
  UPDATE = 'UPDATE',
  DATA_VALIDATION = 'DATA_VALIDATION',
  REMOVE = 'REMOVE',
  CONTAINS = 'CONTAINS',
  CLEAR_SHACL = 'CLEAR_SHACL',
  GET_GRAPHQL = 'GET_GRAPHQL',
  GET_SOML = 'GET_SOML',
  GET_SHACL = 'GET_SHACL',
  VALIDATE = 'VALIDATE',
  VALIDATE_STRICT = 'VALIDATE_STRICT',
  VALIDATE_GRAPHQL = 'VALIDATE_GRAPHQL',
  VALIDATE_SHACL = 'VALIDATE_SHACL',
  REBIND_SHACL = 'REBIND_SHACL',
  RELOAD = 'RELOAD',
  REBIND_SERVICE = 'REBIND_SERVICE',
  HEALTH = 'HEALTH',
  CHECK_REQUIREMENTS = "CHECK_REQUIREMENTS",
  CREATE_CONNECTOR = 'CREATE_CONNECTOR',
  DROP_CONNECTOR = 'DROP_CONNECTOR',
  PREPARE_ELASTIC = 'PREPARE_ELASTIC',
  CREATE_ALIASES = 'CREATE_ALIASES',
  MANAGE_INDEXES = 'MANAGE_INDEXES'
}
